import { render, staticRenderFns } from "./buyer-seller-split.vue?vue&type=template&id=7aadd012"
import script from "./buyer-seller-split.vue?vue&type=script&lang=js"
export * from "./buyer-seller-split.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports